import * as yup from 'yup';
import { passwordRule, confirmPasswordRule } from 'utils/validation-rules';
import { TFunction } from 'i18next';

export const ResetPasswordSchema = (t: TFunction) =>
  yup.object({
    password: passwordRule(t),
    password_confirm: confirmPasswordRule('password', t),
  });
